import { brandPrimaryHoverTint, label, white } from '@Styles/colors';
import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../../web/components-v2/Theme/theme';
import { BreakPoints } from '../../../../../../../web/styles/styles';

const { spacing, common, typography, colors } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		padding: spacing.md,
		backgroundColor: white,
	},
	subtitle: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		margin: spacing.md,
	},
	actionBar: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		alignItems: 'center',
		gap: spacing.md,
		padding: spacing.md,
		borderBottom: common.border,
	},
	filterSection: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'center',
		flex: '1 1 auto',
		minWidth: 0,
		gap: spacing.md,
	},
	filterGroup: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
	},
	searchInput: {
		flex: '1 1 180px',
		minWidth: 0,
		maxWidth: 220,
	},
	filterLabel: {
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.standard,
		whiteSpace: 'nowrap',
		alignSelf: 'center',
	},
	buttonGroup: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		gap: spacing.sm,
	},
	tableContainer: {
		height: 400,
		overflowY: 'auto' as const,
		border: common.border,
		borderRadius: common.borderRadius,
	},
	emptyState: {
		padding: spacing.lg,
		textAlign: 'center' as const,
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
	},
	tableOverrides: {
		width: '100%',
		tableLayout: 'fixed',
		minHeight: 'auto',
	},
	columnOverrides: {
		'& tr': {
			background: brandPrimaryHoverTint,
		},
	},
	autoCompleteDropdownContent: {
		maxHeight: 200,
		overflowY: 'auto',
	},
	autoCompleteDropdownItems: {
		padding: `${spacing.sm}px ${spacing.md}px`,
		cursor: 'pointer',
		':hover': {
			backgroundColor: 'rgba(0, 0, 0, 0.05)',
		},
	},
	userInput: {
		color: label,
		fontSize: typography.fontSizes.xs,
		width: 200,
		[BreakPoints.forMinWidth(900)]: {
			width: 300,
		},
		[BreakPoints.forMinWidth(850)]: {
			[BreakPoints.forMaxWidth(900)]: {
				width: 250,
			},
		},
	},
	readOnlyText: {
		textAlign: 'left',
	},
	userNameCell: {
		display: 'flex',
		alignItems: 'center',
		minHeight: 40,
		gap: spacing.sm,
	},
	userNameContent: {
		flex: '1',
		minWidth: '0',
	},
	emptyCell: {
		color: colors.text.light,
	},
	footer: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: spacing.md,
		gap: spacing.md,
	},
	footerCount: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
	},
	pendingEditsCount: {
		color: colors.warning.main,
	},
	// Match FieldMappings row treatment for "this row has unsaved edits"
	modifiedRow: {
		backgroundColor: colors.warning.light,
		borderLeft: `3px solid ${colors.warning.main}`,
	},
	statusIndicatorContainer: {
		width: 120,
		flexShrink: 0,
		textAlign: 'right' as const,
		fontSize: typography.fontSizes.xs,
	},
	modifiedIndicator: {
		color: colors.warning.main,
		fontSize: typography.fontSizes.xxs,
		fontWeight: typography.fontWeights.bold,
		marginLeft: 0,
		display: 'block',
		whiteSpace: 'nowrap' as const,
	},
});
